module.exports = __webpack_public_path__ + "img/nicoId.3cf7c0c4.webp";